import { EnumPermission } from 'src/app/core/models/enum';
import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 0,
        label: 'Dashboards',
        icon: 'bx bxs-dashboard',
        link: '/dashboard',
    },
    // {
    //     id: 0,
    //     label: 'Sample',
    //     icon: 'bx bx-layer',
    //     link: '/template/icons/boxicons',
    // },
    {
        id: 1,
        label: 'Announcement',
        icon: 'bx bxs-bell-ring',
        link: '/announcement/list',
        permission: [EnumPermission.ANNOUNCEMENT_VIEW]
    },
    {
        id: 1,
        label: 'Contact Us',
        icon: 'bx bx-mail-send',
        link: '/contactUs/list',
        permission: [EnumPermission.CONTACT_US_VIEW]
    },
    {
        id: 1,
        label: 'FAQ',
        icon: 'bx bx-message-square-dots',
        link: '/faq/list',
        permission: [EnumPermission.FAQ_VIEW]
    },
    {
        id: 0,
        label: 'Company',
        isTitle: true,
        permission: [EnumPermission.COMPANY_VIEW, EnumPermission.COMPANY_ADD, EnumPermission.COMPANY_EDIT]
    },
    {
        id: 1,
        label: 'Company',
        icon: 'bx bx-user',
        link: '/company/list',
        permission: [EnumPermission.COMPANY_VIEW]
    },
    {
        id: 1,
        label: 'Industry',
        icon: 'mdi mdi-home-city-outline',
        link: '/industry/list',
        permission: [EnumPermission.INDUSTRY_VIEW]
    },
    // {
    //     id: 1,
    //     label: 'Download Log',
    //     icon: 'bx bx-list-ul',
    //     link: '/downloadLog/list',
    //     permission: [EnumPermission.DOWNLOAD_LOG_VIEW]
    // },
    {
        id: 0,
        label: 'SAN',
        isTitle: true
    },
    {
        id: 1,
        label: 'San',
        icon: 'bx bxs-file',
        link: '/san/list',
        permission: [EnumPermission.SAN_VIEW]
    },
    {
        id: 0,
        label: 'User Management',
        isTitle: true,
    },
    {
        id: 1,
        label: 'User',
        icon: 'bx bx-user-circle',
        link: '/admin/list',
        permission: [EnumPermission.ADMIN_VIEW]
    },
    {
        id: 1,
        label: 'User Role',
        icon: 'bx bx-toggle-right',
        link: '/authority/list',
        permission: [EnumPermission.ADMIN_AUTHORITY_VIEW]
    },
    // {
    //     id: 1,
    //     label: 'Operation Log',
    //     icon: 'bx bx-list-ul',
    //     link: '/log/list',
    //     permission: [EnumPermission.OPERATION_LOG_VIEW]
    // }
];

